import { LabelPrintData } from "src/apis/labelApi";
import { formatDate } from "src/utils/string/stringUtil";

export interface WMS2090_R01StoreData {
	WMS2090_R01DetailList: any[];
	editWMS2090_R01: any;
}

const formatQty = (qty: number | undefined, unit: string): string => {
	if (!qty && qty !== 0) return "";
	return `${qty.toLocaleString()}${unit || "EA"}`;
};

const WMS2090_R01_buildLabelDataFromDetail = (
	detail: any,
	header: any
): LabelPrintData => {
	if (!detail) throw new Error("상세 데이터가 없어 라벨을 생성할 수 없습니다.");
	if (!header) throw new Error("헤더 정보가 없어 라벨을 생성할 수 없습니다.");

	const transportDate = header.transportDt
		? formatDate(new Date(header.transportDt))
		: formatDate(new Date());

	const qty = detail.qty ?? 0;

	return {
		lotNo: detail.lotNo || "",
		itemCd: detail.itemCd || "",
		itemNm: detail.itemNm || "",
		itemSpec: detail.itemSpec || "",
		transportDate,
		itemAccountNm: detail.itemAccountNm || header.inoutMethod || "",
		storageLocation: detail.locationNm || detail.locationCd || "-",
		qty: formatQty(qty, detail.unit || "EA"),
		customer: header.customNm || "",
		customerItemCd: detail.customerItemCd || detail.itemCd || "",
		labelType: "[INITIAL-STOCK]",
	};
};

export const WMS2090_R01_buildLabelData = (
	lotNo: string,
	itemCd: string,
	store: WMS2090_R01StoreData
): LabelPrintData => {
	const { WMS2090_R01DetailList, editWMS2090_R01 } = store;
	const detail = WMS2090_R01DetailList.find((d: any) =>
		(lotNo && d.lotNo === lotNo) || d.itemCd === itemCd
	);
	if (!detail) throw new Error(`상세 데이터를 찾을 수 없습니다: lotNo=${lotNo}, itemCd=${itemCd}`);

	return WMS2090_R01_buildLabelDataFromDetail(detail, editWMS2090_R01);
};

export const WMS2090_R01_buildLabelDataByValueIndex = (
	valueIndex: number,
	itemCd: string,
	store: WMS2090_R01StoreData
): LabelPrintData | null => {
	const { WMS2090_R01DetailList } = store;
	const detail = WMS2090_R01DetailList.find((d: any) => d.valueIndex === valueIndex);

	if (!detail) {
		console.warn(`상세 데이터를 찾을 수 없습니다: valueIndex=${valueIndex}, itemCd=${itemCd}`);
		return null;
	}

	try {
		return WMS2090_R01_buildLabelDataFromDetail(detail, store.editWMS2090_R01);
	} catch (error) {
		console.error("라벨 데이터 생성 중 오류:", error);
		return null;
	}
};

export const WMS2090_R01_extractUnprintedLabelData = (
	store: WMS2090_R01StoreData,
	deletedDetailList: string[] = []
): LabelPrintData[] => {
	const { WMS2090_R01DetailList } = store;
	const unprintedLabelData: LabelPrintData[] = [];
	const deletedSet = new Set(deletedDetailList);

	WMS2090_R01DetailList.forEach((detail: any) => {
		const valueIndex = detail.valueIndex?.toString() ?? "";
		const qty = detail.qty ?? 0;
		if (
			!deletedSet.has(valueIndex) &&
			!detail.printed &&
			qty > 0
		) {
			try {
				unprintedLabelData.push(
					WMS2090_R01_buildLabelDataFromDetail(detail, store.editWMS2090_R01)
				);
			} catch (error) {
				console.error(`라벨 데이터 생성 중 오류: ${detail.lotNo}`, error);
			}
		}
	});

	return unprintedLabelData;
};
